import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import klikLogo from '../assets/klik_logo.png';

export default function Header({ active }) {
  const { dark, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinkStyle = (key) =>
    active === key ? { color: 'var(--accent)', fontWeight: 700 } : undefined;

  return (
    <header className="kh-header">
      <Link to="/" className="kh-brand">
        <img src={klikLogo} alt="KLIK Innovatech" className="kh-brand-logo" />
        <span className="kh-brand-name">KLIK INNOVATECH</span>
      </Link>

      <nav className="kh-nav-links">
        <Link to="/" className="kh-nav-link" style={navLinkStyle('home')}>Home</Link>
        <div className="kh-nav-pages">
          <a href="#!" className="kh-nav-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
            Pages
            <svg width="13" height="13" style={{ color: 'var(--faint)' }}><use href="#i-chevron" /></svg>
          </a>
          <div className="kh-dropdown">
            <a href="#!">Portfolio</a>
            <a href="#!">Our Team</a>
            <a href="#!">Pricing</a>
            <a href="#!">FAQs</a>
            <a href="#!">Careers</a>
          </div>
        </div>
        <div className="kh-nav-pages">
          <Link to="/products" className="kh-nav-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 5, ...navLinkStyle('products') }}>
            Products
            <svg width="13" height="13" style={{ color: 'var(--faint)' }}><use href="#i-chevron" /></svg>
          </Link>
          <div className="kh-dropdown">
            <Link to="/products?cat=aidashcam">AI DashCam</Link>
            <Link to="/products?cat=dashcam">DashCam</Link>
            <Link to="/products?cat=gps">GPS Tracker</Link>
            <Link to="/products?cat=solar">Solar Cam</Link>
            <Link to="/products?cat=accessaries">Accessaries</Link>
          </div>
        </div>
        <Link to="/services" className="kh-nav-link" style={navLinkStyle('services')}>Services</Link>
        <Link to="/about" className="kh-nav-link" style={navLinkStyle('about')}>About Us</Link>
        <a href="#!" className="kh-nav-link" style={navLinkStyle('blog')}>Blog</a>
        <a href="#contact" className="kh-nav-link">Contact Us</a>
      </nav>

      <div className="kh-header-actions">
        <button
          className="kh-toggle"
          onClick={toggleTheme}
          aria-label="Toggle dark and light theme"
        >
          <span className="kh-toggle-knob" style={{ transform: `translateX(${dark ? '24px' : '2px'})` }}>
            <svg width="13" height="13"><use href={dark ? '#i-moon' : '#i-sun'} /></svg>
          </span>
        </button>
        <a href="tel:0717123790" className="kh-btn-primary kh-quote-btn">
          Get a Quote
        </a>
        <button
          className="kh-mobile-toggle"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <svg width="20" height="20"><use href={menuOpen ? '#i-close' : '#i-menu'} /></svg>
        </button>
      </div>

      {menuOpen && (
        <div className="kh-mobile-menu">
          <Link to="/" className="kh-mobile-link" style={navLinkStyle('home')} onClick={() => setMenuOpen(false)}>Home</Link>
          <a href="#!" className="kh-mobile-link" onClick={() => setMenuOpen(false)}>Pages</a>
          <Link to="/products" className="kh-mobile-link" style={navLinkStyle('products')} onClick={() => setMenuOpen(false)}>Products</Link>
          <Link to="/services" className="kh-mobile-link" style={navLinkStyle('services')} onClick={() => setMenuOpen(false)}>Services</Link>
          <Link to="/about" className="kh-mobile-link" style={navLinkStyle('about')} onClick={() => setMenuOpen(false)}>About Us</Link>
          <a href="#!" className="kh-mobile-link" style={navLinkStyle('blog')} onClick={() => setMenuOpen(false)}>Blog</a>
          <a href="#contact" className="kh-mobile-link" onClick={() => setMenuOpen(false)}>Contact Us</a>
          <a href="tel:0717123790" className="kh-btn-primary" style={{ marginTop: 14, justifyContent: 'center' }} onClick={() => setMenuOpen(false)}>
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
}
